import request from "@/utils/request";

// 列表(主数据列表)
export function loadUserAreaListDataApi(data) {
  return request({
    url: "web/userArea/listData",
    method: "post",
    data
  });
}

// 导出(主数据列表)
export function loadUserAreaExportDataApi(data) {
  return request({
    url: "web/userArea/exportData",
    method: "post",
    data
  });
}

// 新增修改
export function saveOrUpdateUserAreaApi(data) {
  return request({
    url: "web/userArea/saveOrUpdate",
    method: "post",
    data
  });
}

// 初始化
export function initUserAreaApi(data) {
  return request({
    url: "web/userArea/initUserArea",
    method: "post",
    data
  });
}

// 根据用户获取用户区域
export function findUserAreaByUserApi(data) {
  return request({
    url: "web/userArea/findUserAreaByUser",
    method: "post",
    data
  });
}
